import { buildApi } from '../util/api.util';

export const coreapi = buildApi(process.env.REACT_APP_CORE_API_URL!);
